"use strict";
/**
 * This is the class for generating ids
 *
 * @class ElstrId
 */
Object.defineProperty(exports, "__esModule", { value: true });
function createUUID() {
    return ElstrId.create();
}
exports.createUUID = createUUID;
var ElstrId = /** @class */ (function () {
    function ElstrId() {
    }
    /**
     * Generate a random uuid. Modified script from:
     * http://www.broofa.com/Tools/Math.uuid.js
     *
     * @return string (RFC4122, version 4 ID)
     */
    ElstrId.create = function () {
        var CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
        var chars = CHARS, uuid = [];
        // rfc4122, version 4 form
        var r;
        // rfc4122 requires these characters
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
        uuid[14] = "4";
        // Fill in random data. At i==19 set the high bits of clock
        // sequence as
        // per rfc4122, sec. 4.1.5
        for (var i = 0; i < 36; i++) {
            if (!uuid[i]) {
                r = 0 | (Math.random() * 16);
                uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r];
            }
        }
        return uuid.join("");
    };
    /**
     * Generate a random uuid.
     * Checks that it was never used before in the same document
     *
     * @return string (RFC4122, version 4 ID)
     */
    ElstrId.createDocumentUnique = function () {
        var newUid = this.create();
        while (newUid in this.generatedIds) {
            newUid = this.create();
            if (process.env.DEBUG) {
                console.error("ElstrId.createDocumentUnique: collision found with " + newUid);
            }
        }
        this.generatedIds[newUid] = true;
        return newUid;
    };
    ElstrId.generatedIds = [];
    return ElstrId;
}());
exports.default = ElstrId;
//# sourceMappingURL=ElstrId.js.map